module.exports = __webpack_public_path__ + "static/poster3-a5ba5cbffaeb1812d71bfb66c8075a53.jpg";